// src/utils/directElevation.js
// Direct elevation without complex paths

import { ref, set, get, push } from 'firebase/database';
import { database } from '../firebase';

// Function to directly set admin privileges for a specific user
const elevateSpecificUser = async () => {
  try {
    const email = 'caylan45@yahoo.com';
    console.log('🔍 Searching for user with email:', email);

    // Get all users from Firebase
    const usersSnapshot = await get(ref(database, 'users'));

    if (!usersSnapshot.exists()) {
      console.error('❌ No users found in database');
      return false;
    }

    const users = usersSnapshot.val();
    let foundUserId = null;

    // Search for the user
    for (const [userId, userData] of Object.entries(users)) {
      if (userData.email === email) {
        foundUserId = userId;
        console.log('✅ Found user:', userData.displayName || userData.firstName || 'User', '- ID:', userId);
        break;
      }
    }

    if (!foundUserId) {
      console.error('❌ User not found with email:', email);
      console.log('Available users:', Object.values(users).map(u => u.email));
      return false;
    }

    // Set admin role directly
    console.log('⚡ Setting admin role...');
    await set(ref(database, `users/${foundUserId}/role`), 'admin');

    // Set admin permissions directly
    console.log('⚡ Setting admin permissions...');
    const permissionsRef = ref(database, `users/${foundUserId}/permissions`);
    await set(permissionsRef, {
      admin: true,
      elevated_at: new Date().toISOString(),
      elevated_by: 'direct_elevation'
    });

    console.log('🎉 SUCCESS! User has been elevated to admin');
    console.log('🔄 Reloading page in 2 seconds...');

    setTimeout(() => {
      window.location.reload();
    }, 2000);

    return true;

  } catch (error) {
    console.error('❌ Error during elevation:', error);
    return false;
  }
};

// Make it available globally
window.elevateSpecificUser = elevateSpecificUser;

console.log('🛠️  Admin elevation utility loaded');
console.log('📋 To elevate caylan45@yahoo.com to admin, run: elevateSpecificUser()');

export default elevateSpecificUser;